import { render, staticRenderFns } from "./NavbarV2Comp.vue?vue&type=template&id=4607d162&scoped=true&"
import script from "./NavbarV2Comp.vue?vue&type=script&lang=js&"
export * from "./NavbarV2Comp.vue?vue&type=script&lang=js&"
import style0 from "./NavbarV2Comp.vue?vue&type=style&index=0&id=4607d162&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4607d162",
  null
  
)

export default component.exports